import React from "react";
import { Container, ContentContainer } from "./styles";

const MainContainer = ({
  children,
}: {
  children: any;
}) => {
  return (
    <Container className="main-container">
      <ContentContainer className="main-content-container">
        {children}
      </ContentContainer>
    </Container>
  );
};

export default MainContainer;
